<ng-container *ngTemplateOutlet="content"></ng-container>

<button mat-button (click)="dismiss($event)">Ok</button>
